import AdminLayout from "components/layout/AdminLayout"
import MarketingLayout from "components/layout/MarketingLayout"
import NewsletterSubscribers from "components/marketing/admin/Subscribers"
import { ReactElement } from "react"

const NewsletterPage = () => {
  return <NewsletterSubscribers />
}

NewsletterPage.getLayout = (page: ReactElement) => {
  return (
    <AdminLayout>
      <MarketingLayout>{page}</MarketingLayout>
    </AdminLayout>
  )
}

export default NewsletterPage
